<template>
  <transition
    name="fade"
    appear
  >
    <slot
      name="content"
    />
  </transition>
</template>

<script>
export default {
  name: 'OwalTransitionFade',
}
</script>

<style scoped>
.fade-enter-active {
  animation-name: fade;
  animation-duration: 300ms;
  animation-timing-function: ease-in;
}

.fade-leave-active, .fade-leave-to {
  animation-name: fade;
  animation-duration: 300ms;
  animation-timing-function: ease-in;
  animation-direction: reverse;
}

@keyframes fade {
  /** Implement keyframes here. */
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

</style>
